<script>
import { mapGetters } from "vuex";
import { CartData } from "../services/storage.service";

export default {
  name: "Modal",

  data() {
    return {
      errors: "",
      tAmount: 0,
      email: null,
      phone: null,
      reg: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },

  computed: {
    ...mapGetters([
      "cartTotal",
      "getPromoDiscountTotal",
      "getVAT",
      "getIntlTransferCharge",
    ]),
  },

  methods: {
    getTotalPrice: function () {
      let extPrice = CartData.getExtCartAmount();
      let cartAmount = CartData.getCartAmount();

      this.tAmount = cartAmount ? cartAmount : extPrice;
    },

    checkForm: function (e) {
      e.preventDefault();

      if (
        this.email == null ||
        this.email == "" ||
        this.phone == null ||
        this.phone == ""
      ) {
        this.errors = "Fields are empty";
      } else {
        if (!this.reg.test(this.email)) {
          this.errors = "Email is not valid";
        } else if (this.phone == null) {
          this.errors = "Phone Number is not valid";
        } else {
          this.errors = "";
          this.phone = e.target[1].value;
          this.email = e.target[0].value;
          this.$emit("phone", e.target[1].value);
          this.$emit("email", e.target[0].value);
          this.$emit("close");
        }
      }
    },

    close() {
      this.$emit("close");
    },
  },

  mounted() {
    this.getTotalPrice();
  },

  watch: {
    userData: function () {
      this.$emit("phone", this.phone);
      this.$emit("email", this.email);
    },
  },
};
</script>

<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header class="modal-header" id="modalTitle">
          <slot name="header">
            Please enter your Email and Phone Number. Purchase receipt will be
            sent to your Email.
          </slot>
        </header>

        <section class="modal-body" id="modalDescription">
          <div class="total-amount-text">NRs. {{ this.tAmount }}</div>

          <slot name="body">
            <div class="error-text">{{ this.errors }}</div>

            <form @submit="checkForm" class="input-field-box">
              <input
                placeholder="Email"
                class="input-field"
                id="email"
                v-model="email"
                type="varchar"
                name="email"
              />

              <input
                placeholder="Phone Number"
                class="input-field"
                id="phone"
                v-model="phone"
                type="varchar"
                name="phone"
              />

              <input class="btn-submit" type="submit" value="Submit" />
            </form>
          </slot>
        </section>

        <!-- <footer class="modal-footer">
          <slot name="footer">
            <button
              type="button"
              class="btn-cancel"
              @click="close"
              aria-label="Close modal"
            >
              Cancel
            </button>
          </slot>
        </footer> -->
      </div>
    </div>
  </transition>
</template>

<style lang="scss">
@import "@/styles/variables.scss";

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal {
  background: white;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 40%;
  border-radius: 10px;
}

.modal-header,
.modal-footer {
  padding: 20px;
  display: flex;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: $brand-color;
  font-family: $main-font;
  justify-content: space-between;
  text-align: center;
  font-size: 16px;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
  font-family: $main-font;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-cancel {
  color: $text-color;
  background: none;
  border: none;
  font-size: 10px;
}

.input-field-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
}

.input-field {
  height: 34px;
  width: 60%;
  border: 1px solid $text-color2;
  margin-top: 10px;
  color: $text-color;
  border-radius: 2px;
  text-align: center;
}

.input-field:hover {
  border: 1px solid $brand-color;
}

.input-field:focus {
  border: 1px solid $brand-color;
  outline: none;
}

.btn-submit {
  background-color: $brand-color;
  border: 1px solid $brand-color;
  border-radius: 4px;
  padding: 7px;
  color: white;
  margin-top: 20px;
  font-family: $main-font;
  cursor: pointer;
  text-transform: uppercase;
}

.btn-submit:hover {
  background-color: white;
  border: 1px solid $brand-color;
  color: $brand-color;
}

.total-amount-text {
  text-align: center;
  font-family: $main-font;
  font-size: 18px;
  color: green;
}

.error-text {
  text-align: center;
  font-family: $main-font;
  font-size: 12px;
  color: red;
  padding-top: 20px;
}

@media only screen and (max-width: 425px) {
  .modal {
    background: white;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 300px;
    border-radius: 10px;
  }
}
</style>
